import { render, staticRenderFns } from "./References.vue?vue&type=template&id=b8447b62&scoped=true&"
import script from "./References.vue?vue&type=script&lang=ts&"
export * from "./References.vue?vue&type=script&lang=ts&"
import style0 from "./References.vue?vue&type=style&index=0&id=b8447b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8447b62",
  null
  
)

export default component.exports